import React from "react";
import { Table, Pagination } from "antd";

const TablaRespuestas = ({
  loading,
  respuestas = [],
  pagination = { current: 1, pageSize: 3, total: 0 },
}) => {
  const columns = [
    {
      title: "Cliente",
      dataIndex: "cliente",
      key: "cliente",
    },
    {
      title: "Pregunta",
      dataIndex: "pregunta",
      key: "pregunta",
    },
    {
      title: "Respuesta",
      dataIndex: "respuesta",
      key: "respuesta",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={respuestas}
      rowKey="id"
      pagination={pagination}
      loading={loading}
    />
  );
};

export default TablaRespuestas; 
